import { Testimonials } from './Testimonials/Testimonials'

export const HomePageTestimonials = () => <Testimonials />
